import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { OpenFormComponent } from 'src/app/component/open-form/open-form.component';
import { PagesService } from '../../services/pages.service';
import { jobFairFormField } from '../jobfair/forms/create-jobfair';

@Component({
	selector: 'app-hubble',
	templateUrl: './hubble.page.html',
	styleUrls: ['./hubble.page.scss'],
})
export class HubblePage implements OnInit {
	currentPagePermission = 'hubble';
	isCanOpenBox = true;
	constructor(
		public pagesService: PagesService,
		private popoverController: PopoverController,
	) {
		this.pagesService.notValidPermissionByName(
			this.currentPagePermission,
			'/app',
		);
	}

	ngOnInit() {}


}
